import React, { createContext, useContext, useState } from "react";
import {
  getSelectedColumns as getSelectedColumnsUserSettings,
  setSelectedColumns as setSelectedColumnsUserSettings,
} from "../helper/UserSettingsHelper";
import TestRequestOverviewColumns, {
  configurableColumns,
} from "../pages/Dashboard/TestRequestsTable/TestRequestsOverviewColumns";

type Updater = (column: TestRequestOverviewColumns) => void;
type SelectedColumnsContextType = { selectedColumns: TestRequestOverviewColumns[]; updateSelectedColumns: Updater };

const SelectedColumnsContext = createContext<SelectedColumnsContextType | undefined>(undefined);

function SelectedColumnsProvider({ children }: React.PropsWithChildren<{}>) {
  const [selectedColumns, setSelectedColumns] = useState<TestRequestOverviewColumns[]>(
    getSelectedColumnsUserSettings() || configurableColumns,
  );

  const updateSelectedColumns = (column: TestRequestOverviewColumns) => {
    let newSelectedColumnsUserSettings: TestRequestOverviewColumns[] = [];

    setSelectedColumns((prevState) => {
      if (prevState.includes(column)) {
        const result1 = prevState.filter((col) => col !== column);

        newSelectedColumnsUserSettings = result1;
        return result1;
      }
      const result2 = [column, ...prevState];

      newSelectedColumnsUserSettings = result2;
      return result2;
    });

    setSelectedColumnsUserSettings(newSelectedColumnsUserSettings);
  };
  const value = { selectedColumns, updateSelectedColumns };
  return <SelectedColumnsContext.Provider value={value}>{children}</SelectedColumnsContext.Provider>;
}

function useSelectedColumns() {
  const context = useContext(SelectedColumnsContext);
  if (!context) {
    throw new Error("Wrap useSelectedColumns in a SelectedColumnsProvider.");
  }
  return context;
}

export { SelectedColumnsProvider, useSelectedColumns };
